export const SAVE_USER_MODAL = 'user';
